export const NEW_SEEDLING_INVENTORY_URL = '/app/protected/seedling/inventory';